module.exports = __webpack_public_path__ + "img/fb05.7273fe8c.jpg";